module.exports = __webpack_public_path__ + "img/vertical_3_4_8003.87fb81b2.png";